import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import RadioSlider from 'components/RadioSlider';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import EditQualificationQuestions from './components/EditQualificationQuestions';
import PreviewQualificationQuestions from './components/PreviewQualificationQuestions';
import { Field, Form } from 'react-final-form';
import ToggleField from 'components/ToggleField';
import FormActions from './components/FormActions';
import arrayMutators from 'final-form-arrays';
import { Loader } from 'ncoded-component-library';
import { isEqual } from 'lodash';
import useQualificationQuestionsForm from './hooks/useQualificationQuestionsForm';

import './QualificationQuestions.styles.scss';
import './QualificationQuestions.styles.responsive.scss';

const PREVIEW = 'preview';
const EDIT = 'edit';

const IS_EDIT_MODE_OPTIONS = [PREVIEW, EDIT];

type QualificationQuestionsProps = {
  className?: string;
};

const QualificationQuestions: React.FC<QualificationQuestionsProps> = (
  props,
) => {
  const { className } = props;

  const [isEditMode, setIsEditMode] = useState(false);

  const classes = classNames(
    'qualification-questions',
    'white-panel',
    className,
  );

  const { t } = useTranslation();

  const createSelectOptions = useCreateSelectOptions();

  const isEditModeOptions = useMemo(
    () => createSelectOptions(IS_EDIT_MODE_OPTIONS),
    [createSelectOptions],
  );

  const { initialValues, onCancel, onSubmit } = useQualificationQuestionsForm();

  return (
    <div className={classes}>
      <Form
        onSubmit={onSubmit}
        mutators={{ ...arrayMutators }}
        initialValues={initialValues}
        render={({
          invalid,
          submitting,
          initialValues,
          values,
          form: { submit },
          handleSubmit,
        }) => {
          const isPristine = isEqual(initialValues, values);

          return (
            <form onSubmit={handleSubmit}>
              {submitting && <Loader />}

              <div className="qualification-questions__heading">
                <h1>{t('buyerQualificationsPageHeading')}</h1>
                <Field
                  className="black-toggle"
                  name="enabledQualificationQuestions"
                  type="checkbox"
                  component={ToggleField}
                  onContent={<p>{t('on')}</p>}
                  offContent={<p>{t('off')}</p>}
                />
              </div>

              <div className="qualification-questions__subheading">
                <p className="description">
                  {t('buyerQualificationsPageDescription')}
                </p>
                <RadioSlider
                  value={isEditMode ? EDIT : PREVIEW}
                  slideSteps={isEditModeOptions}
                  onChange={(value) => setIsEditMode(value === EDIT)}
                />
              </div>

              {isEditMode ? (
                <EditQualificationQuestions />
              ) : (
                <PreviewQualificationQuestions />
              )}

              {!isPristine && (
                <FormActions
                  submitDisabled={invalid || submitting}
                  onCancel={() => onCancel(submit)}
                />
              )}
            </form>
          );
        }}
      />
    </div>
  );
};

export default QualificationQuestions;
